import './TextDivider.scss';

const TextDivider: React.FC<{ children: string }> = ({children}) => {
    const text = children.toUpperCase();

    return (
        <div className="text-divider">
            {text}
        </div>
    );
};

export default TextDivider;